module.exports = __webpack_public_path__ + "img/Blow out services.svg";